import React from "react";
import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import SchoolIcon from "@mui/icons-material/School";
import HomeIcon from "@mui/icons-material/Home";

import Role from "../../../policies/Role";
import PoliciesHelper from "../../../policies/PoliciesHelper";
import { AuthContext } from "../../../context/AuthContext";
import "./AdminSidebar.css";

/**
 * Sidebar pour l'enseignant et l'administrateur.
 */
class AdminSidebar extends React.Component {
  static contextType = AuthContext;

  getSections = (role) => {
    const policiesHelper = new PoliciesHelper(role);

    return [
      {
        title: "Utilisateurs",
        items: policiesHelper.getvisibleRoutes([
          {
            label: "Utilisateurs",
            icon: <PeopleIcon />,
            path: "/admin/users",
            minimumRole: Role.Teacher,
          },
          {
            label: "Administrateurs",
            icon: <PeopleIcon />,
            path: "/admin/admin_users",
            minimumRole: Role.Admin,
          },
          {
            label: "Codes enseignants",
            icon: <SchoolIcon />,
            path: "/admin/teacher_codes",
            minimumRole: Role.Admin,
          },
        ]),
      },
      {
        title: "Badges",
        items: policiesHelper.getvisibleRoutes([
          {
            label: "Liste des badges",
            icon: <AssignmentIcon />,
            path: "/admin/badges",
            minimumRole: Role.Teacher,
          },
          {
            label: "Catégories",
            icon: <AssignmentIcon />,
            path: "/admin/categories",
            minimumRole: Role.Teacher,
          },
        ]),
      },
      {
        title: "Statistiques",
        items: policiesHelper.getvisibleRoutes([
          {
            label: "Top 10 collectionneurs",
            icon: <InsertChartIcon />,
            path: "/admin/top-collectors",
            minimumRole: Role.Teacher,
          },
          {
            label: "Top 5 par catégorie",
            icon: <InsertChartIcon />,
            path: "/admin/top-by-category",
            minimumRole: Role.Teacher,
          },
        ]),
      },
    ];
  };

  renderTopLink(item) {
    const currentPath = window.location.pathname;
    const isActive =
      item.path === "/" ? currentPath === "/" : currentPath === item.path;

    return (
      <ListItem key={item.path} disablePadding>
        <ListItemButton
          component={NavLink}
          to={item.path}
          className={`admin-sidebar-link admin-sidebar-top-link${
            isActive ? " active" : ""
          }`}
          sx={{
            background: "#ffffff",
            color: "#111827",
            mx: "12px",
            my: "10px",
            borderRadius: "12px",
            border: "1px solid rgba(37, 99, 235, 0.25)",
            boxShadow: "0 3px 10px rgba(15, 23, 42, 0.10)",
            transition: "all 0.22s ease",

            "&:hover": {
              background: "#ffffff",
              color: "#2563eb",
              transform: "translateY(-1px)",
              boxShadow: "0 5px 14px rgba(37, 99, 235, 0.18)",
              borderColor: "rgba(37, 99, 235, 0.45)",
            },

            "& .MuiListItemIcon-root": {
              color: "inherit",
              minWidth: "38px",
            },

            "& .MuiListItemText-primary": {
              color: "inherit",
              fontWeight: 700,
            },
          }}
        >
          <ListItemIcon className="admin-sidebar-icon">
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.label} />
        </ListItemButton>
      </ListItem>
    );
  }

  renderSectionItem(item) {
    const currentPath = window.location.pathname;
    const isActive = currentPath === item.path;

    return (
      <ListItem key={item.path} disablePadding>
        <ListItemButton
          component={NavLink}
          to={item.path}
          className={`admin-sidebar-link${isActive ? " active" : ""}`}
        >
          <ListItemIcon className="admin-sidebar-icon">
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.label} />
        </ListItemButton>
      </ListItem>
    );
  }

  render() {
    const sections = this.getSections(this.context?.user?.role);
    const isAdmin = this.context?.user?.role === Role.Admin || this.context?.user?.role === Role.AdminContact;

    const topLink = [
      {
        label: "Retour au site",
        icon: <HomeIcon />,
        path: isAdmin ? "/feed" : "/",
      },
      {
        label: "Tableau de bord",
        icon: <DashboardIcon />,
        path: isAdmin ? "/admin" : "/",
      },
    ];

    return (
      <Box className="admin-sidebar">
        <List className="admin-sidebar-top">
          {topLink.map((item) => this.renderTopLink(item))}
        </List>

        {sections.map((section) => (
          <div key={section.title} className="admin-sidebar-section">
            <div className="admin-sidebar-section-title">{section.title}</div>

            <List>
              {section.items.map((item) => this.renderSectionItem(item))}
            </List>
          </div>
        ))}
      </Box>
    );
  }
}

export default AdminSidebar;
